module.exports = __webpack_public_path__ + "static/media/lionsgate.292ccbd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/lionsgate.png
// module id = 689
// module chunks = 0